import { useEffect, useState } from 'react';

/** Felder, die auf dem iPhone die Tastatur öffnen. */
const NO_KEYBOARD = new Set([
  'button',
  'checkbox',
  'color',
  'file',
  'hidden',
  'image',
  'radio',
  'range',
  'reset',
  'submit',
]);

export function opensKeyboard(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target instanceof HTMLTextAreaElement) return !target.readOnly;
  if (target instanceof HTMLInputElement) return !target.readOnly && !NO_KEYBOARD.has(target.type);
  return target.isContentEditable === true;
}

/**
 * Ist gerade die Tastatur offen? (25.10.2026)
 *
 * iOS rechnet feste Elemente bei offener Tastatur gegen den verschobenen
 * Ausschnitt: Die Reiterleiste unten lief mit dem Inhalt mit und saß mitten
 * im Bild (am iPhone gesehen). Statt dagegen anzurechnen, tritt die Leiste
 * beim Tippen zurück — wie in nativen Apps.
 */
export function useTyping(): boolean {
  const [typing, setTyping] = useState(() => opensKeyboard(document.activeElement));
  useEffect(() => {
    const onIn = (event: FocusEvent) => setTyping(opensKeyboard(event.target));
    // `relatedTarget`: Springt der Fokus direkt ins nächste Feld, bleibt die
    // Tastatur offen — die Leiste darf dazwischen nicht aufblitzen.
    const onOut = (event: FocusEvent) => setTyping(opensKeyboard(event.relatedTarget));
    document.addEventListener('focusin', onIn);
    document.addEventListener('focusout', onOut);
    return () => {
      document.removeEventListener('focusin', onIn);
      document.removeEventListener('focusout', onOut);
    };
  }, []);
  return typing;
}
